<script lang="ts">
    
    import { onDestroy, onMount } from "svelte";

    const formatter = new Intl.DateTimeFormat('es-ES', {
        dateStyle: 'medium',
        timeStyle: 'medium',
    });

    let interval: number;
    let clockString = '';

    onMount(startClock);
    onDestroy(stopClock);

    function startClock(): void {
        updateClock();
        interval = window.setInterval(updateClock, 1000);
    }

    function stopClock(): void {
        window.clearInterval(interval);
    }

    function updateClock(): void {
        const date = new Date();
        clockString = formatter.format(date);
    }

</script>

{clockString}
